import { subscribePersonas, getChoferes, getChoferesLarga, getChoferesMov, getFleteros, getMecanicos, getAdministrativos, getSerenos } from "./cols/personas.service";
import { subscribeTractores, getTractoresActivos } from "./cols/tractores.service";
import { subscribeFurgones, getFurgonesActivos } from "./cols/furgones.service";
import { subscribeVehiculos, getVehiculosActivos } from "./cols/vehiculos.service";
import { subscribeAsignaciones } from "./cols/asignaciones.service";
import { subscribeProveedores } from "./cols/proveedores.service";
import { subscribeStock, reenriquecerStock } from "./cols/stock.service";
import { subscribeDepositos } from "./cols/depositos.service";
import { subscribeUbicaciones } from "./cols/ubicaciones.service";
import { subscribeEventos, subscribeEventosByArea, getEventosPorteria, getEventosTrafico, reenriquecerEventos } from "./cols/eventos.service";
import { subscribeClientes } from "./cols/clientes.service";
import { subscribeViajes, reenriquecerViajes } from "./cols/viajes.service";
import { subscribeCargasCombustible } from "./cols/cargasCombustible.service";
import { subscribeUsers } from "./users.service";
import { useState, useEffect } from "react";

// -------------------------------------------------- listeners
const listeners = {};

const notifyListeners = (key) => {
  listeners[key]?.forEach(cb => cb(realtime[key]));
};

const subscribeRealtime = (key, callback) => {
  if (!listeners[key]) listeners[key] = new Set();
  listeners[key].add(callback);
  return () => listeners[key].delete(callback);
};

// -------------------------------------------------- store
export const realtime = {
  loading: true,
  // eventos
  eventos: [],
  eventosPorteria: [],
  eventosSatelital: [],
  eventosTrafico: [],
  // personas
  personas: [],
  choferes: [],
  choferesLarga: [],
  choferesMov: [],
  fleteros: [],
  mecanicos: [],
  administrativos: [],
  serenos: [],
  // empresas
  proveedores: [],
  // elementos
  stock: [],
  depositos: [],
  ubicaciones: [],
  // asignaciones
  asignaciones: [],
  // viajes / combustible
  viajes: [],
  clientes: [],
  cargasCombustible: [],
  // usuarios de la app (perfil: nombre, rol, foto)
  users: [],
};

// -------------------------------------------------- iniciar
export const iniciarRealtime = () => {

  const unsubPersonas = subscribePersonas((ps) => {
    realtime.personas = ps;
    realtime.choferes = getChoferes(ps);
    realtime.choferesLarga = getChoferesLarga(ps);
    realtime.choferesMov = getChoferesMov(ps);
    realtime.fleteros = getFleteros(ps);
    realtime.mecanicos = getMecanicos(ps);
    realtime.administrativos = getAdministrativos(ps);
    realtime.serenos = getSerenos(ps);

    notifyListeners("personas");
    notifyListeners("choferes");
    notifyListeners("choferesLarga");
    notifyListeners("choferesMov");
    notifyListeners("fleteros");
    notifyListeners("mecanicos");
    notifyListeners("administrativos");
    notifyListeners("serenos");
    reenriquecerViajes(); // personas trae el nombre del chofer en viajes
    reenriquecerEventos(); // y el de la persona en eventos (portería)

    console.log("[Realtime] Personas:", ps.length);
  });

  const unsubUbicaciones = subscribeUbicaciones((ub) => {
    realtime.ubicaciones = ub;

    notifyListeners("ubicaciones");

    console.log("[Realtime] Ubicaciones:", ub.length);
  })

  const unsubTractores = subscribeTractores((tr) => {
    realtime.tractores = tr;
    realtime.tractoresActivos = getTractoresActivos(tr);

    notifyListeners("tractores");
    notifyListeners("tractoresActivos");
    reenriquecerEventos(); // tractores trae la etiqueta del tractor en eventos

    console.log("[Realtime] Tractores:", tr.length);
  });

  const unsubFurgones = subscribeFurgones((fg) => {
    realtime.furgones = fg;
    realtime.furgonesActivos = getFurgonesActivos(fg);

    notifyListeners("furgones");
    notifyListeners("furgonesActivos");
    reenriquecerViajes(); // furgones trae el dominio del furgón en viajes
    reenriquecerEventos(); // y la etiqueta del furgón en eventos

    console.log("[Realtime] Furgones:", fg.length);
  });

  const unsubVehiculos = subscribeVehiculos((vh) => {
    realtime.vehiculos = vh;
    realtime.vehiculosActivos = getVehiculosActivos(vh);

    notifyListeners("vehiculos");
    notifyListeners("vehiculosActivos");

    console.log("[Realtime] Vehiculos:", vh.length);
  });

  const unsubProveedores = subscribeProveedores((pv) => {
    realtime.proveedores = pv;

    notifyListeners("proveedores");

    console.log("[Realtime] Proveedores:", pv.length);
  });

  const unsubStock = subscribeStock((st) => {
    realtime.stock = st;

    notifyListeners("stock");

    console.log("[Realtime] Stock:", st.length);
  });

  const unsubDepositos = subscribeDepositos((dp) => {
    realtime.depositos = dp;

    notifyListeners("depositos");
    reenriquecerStock(); // la ficha del artículo dice cuánto hay en cada depósito

    console.log("[Realtime] Depositos:", dp.length);
  });




  // dentro de iniciarRealtime:
  const unsubAsignaciones = subscribeAsignaciones((as) => {
    realtime.asignaciones = as;

    notifyListeners("asignaciones");

    console.log("[Realtime] Asignaciones:", as.length)
  });

  const unsubClientes = subscribeClientes((cl) => {
    realtime.clientes = cl;
    notifyListeners("clientes");
    reenriquecerViajes(); // clientes trae el nombre del cliente en viajes
    console.log("[Realtime] Clientes:", cl.length);
  });

  const unsubCargasCombustible = subscribeCargasCombustible((cc) => {
    realtime.cargasCombustible = cc;
    notifyListeners("cargasCombustible");
    reenriquecerViajes(); // cargas traen cantidadCargas/internoActual
    console.log("[Realtime] Cargas de combustible:", cc.length);
  });

  const unsubUsers = subscribeUsers((us) => {
    realtime.users = us;
    notifyListeners("users");
    reenriquecerViajes(); // users trae nombre/foto de quien cargó el viaje
    console.log("[Realtime] Usuarios:", us.length);
  });

  const unsubViajes = subscribeViajes((vj) => {
    realtime.viajes = vj;
    notifyListeners("viajes");
    console.log("[Realtime] Viajes:", vj.length);
  });

  const unsubEventos = subscribeEventos((eventos) => {
    realtime.eventos = eventos;
    realtime.eventosTrafico = getEventosTrafico(eventos);

    notifyListeners("eventos");
    notifyListeners("eventosTrafico");

    console.log("[Realtime] Eventos:", eventos.length);
  });

  /* Portería con SU suscripción y no recortada de la general: las 500 de
   * `eventos` son de todas las áreas, y lo de portería quedaba en lo que
   * sobraba (ticket 420: «se cargan pero no aparecen en el listado»). */
  const unsubEventosPorteria = subscribeEventosByArea("porteria", (eventos) => {
    realtime.eventosPorteria = getEventosPorteria(eventos);
    notifyListeners("eventosPorteria");
    console.log("[Realtime] Portería:", eventos.length);
  }, 500);

  const unsubEventosSatelital = subscribeEventosByArea("satelital", (eventos) => {
    realtime.eventosSatelital = eventos;
    notifyListeners("eventosSatelital");
    console.log("[Realtime] Satelital:", eventos.length);
  });

  realtime.loading = false;

  // y en el return:
  return () => {
    unsubUbicaciones?.();
    unsubStock?.();
    unsubPersonas?.();
    unsubTractores?.();
    unsubFurgones?.();
    unsubVehiculos?.();
    unsubProveedores?.();
    unsubAsignaciones?.();
    unsubClientes?.();
    unsubCargasCombustible?.();
    unsubUsers?.();
    unsubViajes?.();
    unsubEventos?.();
    unsubEventosSatelital?.();
    unsubEventosPorteria?.();
    unsubDepositos?.();
  };
};

// -------------------------------------------------- hook
export const useRealtime = (key) => {
  const [data, setData] = useState(realtime[key] || []);

  useEffect(() => {
    setData(realtime[key] || []); // carga inicial por si ya hay datos
    const unsub = subscribeRealtime(key, setData);
    return unsub;
  }, [key]);

  return data;
};